module.exports = __webpack_public_path__ + "static/media/workout8.d33fe986.jpg";